import React from "react";
import loadable, { loadableReady } from '@loadable/component';
import ReactDOM from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";
import "../src/refresh.js";
// import { render } from "react-dom";                 // add this
import { hydrateRoot } from 'react-dom/client';

// const root = ReactDOM.createRoot(document.getElementById("root"));
// hydrateRoot(document.getElementById("root"), <App />);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
